
//https://noticia.somosconexaosocial.org/backnoticia
//http://localhost:3002

export const API_BASE_URL_NOTICIAS = 'https://noticia.somosconexaosocial.org';



// SERVIDOR IMAGENS
// 'https://somosconexaosocial.org'
// 'http://localhost:3002'

export const API_IMAGEM_URL = 'https://somosconexaosocial.org';



//https://sra2.somosconexaosocial.org/doacoes
//http://localhost:3001

export const API_BASE_URL_DOACOES = 'https://sra2.somosconexaosocial.org/doacoes';
